import React from "react";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Pages
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";

// Administration
import Usuarios from "../pages/Administration/usuarios";
import Clientes from "../pages/Administration/clientes";
import Productos from "../pages/Administration/productos";
import TiposSolicitud from "../pages/Administration/tipos_solicitud";
import TiposPinza from "../pages/Administration/tipos_pinza";
import Material from "../pages/Administration/materiales/material";
import Medidas from "../pages/Administration/materiales/medidas";
import TipoMaterial from "../pages/Administration/materiales/tipo_material";
import ProcesoProveedorPage from "../pages/Administration/proceso_proveedor/ProcesoProveedorPage";
import CargaParametrosPage from "../pages/Administration/CargaParametrosPage";

// Centro de Costos
import Maquinas from "../pages/Administration/centro_costo/maquina";
import CentroCostos from "../pages/Administration/centro_costo/centro_costo";

// Subprocesos
import SubBrillo from "../pages/Administration/subprocesos/sub_brillo";
import SubPlastificado from "../pages/Administration/subprocesos/sub_plastificado";
import SubTroquelado from "../pages/Administration/subprocesos/sub_troquelado";
import SubPegue from "../pages/Administration/subprocesos/sub_pegue";
import SubAcabados from "../pages/Administration/subprocesos/sub_acabados";

// Tintas Management
import { TintasManagementPage } from "../pages/TintasManagementPage";

// Inventarios
import InventarioEntradas from "../pages/Administration/inventarios/InventarioEntradas";
import InventarioSalidas from "../pages/Administration/inventarios/InventarioSalidas";
import InventarioSolicitudes from "../pages/Administration/inventarios/InventarioSolicitudes";
import UnidadPage from "../pages/Administration/inventarios/UnidadPage";
import InventarioMaterialesPage from "../pages/Administration/inventarios/InventarioMaterialesPage";

// Ordenes
import OrdenProduccion from "../pages/Ordenes/orden_produccion";
import OrdenActiva from "../pages/Ordenes/activas/orden_activa";
import OrdenFinalizada from "../pages/Ordenes/finalizadas/orden_finalizada";

// Producción
import PlanificadorTareas from "../pages/Produccion/planificador_tareas";
import TareasEnProceso from "../pages/Produccion/tareas_en_proceso";
import ColaOperarios from "../pages/Produccion/cola-operarios";
import ColaExterna from "../pages/Produccion/ColaExterna";

// Exportación
import CentroCostosExportPage from "../pages/Exportacion/CentroCostosExportPage";
import InformeOPPage from "../pages/Exportacion/InformeOPPage";
import InformeOperariosPage from "../pages/Exportacion/InformeOperariosPage";
import InformeReservaInventarioPage from "../pages/Exportacion/InformeReservaInventarioPage";

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // Profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  { path: "/", component: <Dashboard /> },
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
];

const administrationRoutes = [
  { path: "/usuarios", component: <Usuarios /> },
  { path: "/clientes", component: <Clientes /> },
  { path: "/productos", component: <Productos /> },
  { path: "/tipos-solicitud", component: <TiposSolicitud /> },
  { path: "/tipos-pinza", component: <TiposPinza /> },
  { path: "/centro-costo/maquina", component: <Maquinas /> },
  { path: "/centro-costo/centro-costo", component: <CentroCostos /> },
  { path: "/materiales/material", component: <Material /> },
  { path: "/materiales/medidas", component: <Medidas /> },
  { path: "/materiales/tipo-material", component: <TipoMaterial /> },
  { path: "/tintas", component: <TintasManagementPage /> },
  { path: "/inventarios/entradas", component: <InventarioEntradas /> },
  { path: "/inventarios/salidas", component: <InventarioSalidas /> },
  { path: "/inventarios/solicitudes", component: <InventarioSolicitudes /> },
  { path: "/inventarios/unidad", component: <UnidadPage /> },
  { path: "/inventarios/materiales", component: <InventarioMaterialesPage /> },
  { path: "/subprocesos/brillo", component: <SubBrillo /> },
  { path: "/subprocesos/plastificado", component: <SubPlastificado /> },
  { path: "/subprocesos/troquelado", component: <SubTroquelado /> },
  { path: "/subprocesos/pegue", component: <SubPegue /> },
  { path: "/subprocesos/acabados", component: <SubAcabados /> },
  { path: "/proceso-proveedor", component: <ProcesoProveedorPage /> },
  { path: "/carga-parametros", component: <CargaParametrosPage /> },
];

const ordenRoutes = [
  { path: "/produccion/orden-produccion", component: <OrdenProduccion /> },
  { path: "/produccion/orden-produccion/activas", component: <OrdenActiva /> },
  { path: "/produccion/orden-produccion/finalizadas", component: <OrdenFinalizada /> },
  { path: "/produccion/planificador-tareas", component: <PlanificadorTareas /> },
  { path: "/produccion/tareas", component: <TareasEnProceso /> },
  { path: "/produccion/cola-operarios", component: <ColaOperarios /> },
  { path: "/produccion/externo", component: <ColaExterna /> },
];

const exportacionRoutes = [
  { path: "/exportacion/centro-costos", component: <CentroCostosExportPage /> },
  { path: "/exportacion/informe-op", component: <InformeOPPage /> },
  { path: "/exportacion/informe-operarios", component: <InformeOperariosPage /> },
  { path: "/exportacion/informe-reservas-inventario", component: <InformeReservaInventarioPage /> },
];

export { userRoutes, authRoutes, administrationRoutes, ordenRoutes, exportacionRoutes };
